import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

addToListLinkStyles.wrapper = {
    css: css`
        text-align: left;
        font-family:"Roboto-Bold";
        font-size: 14px;
        line-height: 24px;
        ${TypographyStyle}{
            color:${getColor("text.accent")};;
        }
    `,
};
